import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {take} from 'rxjs/operators';
import {Compbaser} from '../compbaser/compbases';
import {IPlayerProps} from '../../interfaces';
import {StoreSelectorsService} from "../../services";
import {DialogGetAssetComponent, IDialogGetAsset, IDialogGetAssetMode} from '../dialog-get-asset/dialog-get-asset.component';
import {actionSceneJumpLinked, actionSelectedSceneTouchId} from '../../store/actions/user.actions';
import { SceneMimeTypes } from 'app/containers/editor/scene-blocks/mime-constants';
import { TouchLib } from 'app/containers/editor/touch/touchLib';

@Component({
    selector: 'app-scene-selector',
    templateUrl: './scene-selector.component.html',
    styleUrls: ['./scene-selector.component.scss']
})
export class SceneSelectorComponent extends Compbaser implements OnInit {
    selectedScene: IPlayerProps;

    @Input() currentSceneId = '';
    @Input() currentSceneName = '';
    @Input() selectedSceneId = '';
    @Input() showJump = true;
    @Input() previewMode = true;
    @Input() includeLibrary = false;
    @Input() setMode: IDialogGetAssetMode;
    @Input() mimeType = '';
    @Input() includeSelf = false;

    @Output() changeSelectedScene: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        public storeSelector: StoreSelectorsService,
        protected override dialog: MatDialog,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        if (!this.selectedSceneId) {
            if (!this.currentSceneId) return;
            this.selectedSceneId = this.currentSceneId;
        }
        this.cod(
            this.storeSelector.listenSceneData(this.selectedSceneId).subscribe((_scene) => {
                if (_scene) {
                    this.selectedScene = _scene;
                }
            })
        );
    }

    openSceneAssignmentDialog() {
        let data: IDialogGetAsset;
        if (this.setMode) {
            data = {
                mode: this.setMode,
                multiSelect: false,
                mimeType: this.mimeType,
                includeSelf: this.includeSelf,
            };
        } else {
            data = {
                mode: this.includeLibrary ? "SCENE:PLAYER" : "SCENE:ALL",
                multiSelect: false,
                mimeType: '',
            };
        }
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((dialogGetAsset: IDialogGetAsset) => {
                    if (!dialogGetAsset) return;
                    this.selectedScene = dialogGetAsset.sourceData;
                    this.selectedSceneId = dialogGetAsset.selected;
                    this.changeSelectedScene.emit(this.selectedSceneId);
                })
        );
    }

    linkToOtherScene() {
        if (!this.selectedScene || !this.selectedScene.Player.$.id) return;
        if (this.currentSceneId) {
            this.storeSelector.dispatch(actionSceneJumpLinked({previousLinkedSceneId: this.currentSceneId}));
        }
        if (this.selectedScene.Player.$.mimeType === SceneMimeTypes.Touch) {
            const firstChildSceneId = TouchLib.getFirstSlideSceneId(this.selectedScene);
            this.storeSelector.dispatch(actionSelectedSceneTouchId(
                TouchLib.createSelectedSliderPayload(
                    this.selectedScene.Player.$.id,
                    this.selectedScene.Player.$.label,
                    firstChildSceneId,
                ),
            ));
            this.router.navigateByUrl(`/editor/touch/scene/${this.selectedScene.Player.$.id}`);
        } else {
            this.router.navigateByUrl(`/editor/scene/${this.selectedScene.Player.$.id}`);
        }
    }

    resetSelection() {
        this.selectedSceneId = this.currentSceneId || '';
        this.selectedScene = null;
        this.changeSelectedScene.emit(this.selectedSceneId);
    }
}
